import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, } from '@mui/material';
import dayjs from 'dayjs';
import '@fontsource/lato';
export const DataLogTable = ({ items }) => {
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, { style: { backgroundColor: '#EEEEEE', color: '#000000DE', fontFamily: 'Barlow', fontWeight: '500' } },
                    React.createElement(TableCell, null, "Date"),
                    React.createElement(TableCell, null, "Data Received"),
                    React.createElement(TableCell, null, "Data Source"),
                    React.createElement(TableCell, null, "Physiologic Metric"))),
            React.createElement(TableBody, null, items.map((dataLog, index) => (React.createElement(TableRow, { key: index, sx: {
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                } },
                React.createElement(TableCell, { style: { color: 'var(--text-primary, rgba(0, 0, 0, 0.87))', fontSize: 14, fontFamily: 'Lato', fontWeight: '400', overflowWrap: 'anywhere' } }, dayjs(dataLog['created_at']).format('MMMM D, YYYY')),
                React.createElement(TableCell, { style: { color: 'var(--text-primary, rgba(0, 0, 0, 0.87))', fontSize: 14, fontFamily: 'Lato', fontWeight: '400', overflowWrap: 'anywhere' } }, dataLog['data_received']),
                React.createElement(TableCell, { style: { color: 'var(--text-primary, rgba(0, 0, 0, 0.87))', fontSize: 14, fontFamily: 'Lato', fontWeight: '400', overflowWrap: 'anywhere' } }, "SweetSpot"),
                React.createElement(TableCell, { style: { color: 'var(--text-primary, rgba(0, 0, 0, 0.87))', fontSize: 14, fontFamily: 'Lato', fontWeight: '400', overflowWrap: 'anywhere' } }, "Glucose"))))))));
};
